import React from 'react';
import Stack from "@mui/material/Stack";
import Alert from '@mui/material/Alert';
import {Button} from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {history, uxscreen} from "../_services/essentials/helpers";
export { NoRecordsFound };

function NoRecordsFound(props) {
    return (
        <Stack direction="column" sx={{ width: uxscreen.size10}} >
            <Stack direction="column" size={6} sx={{ flexGrow: '1', gap: 1, mt: 1, width: uxscreen.size4}}>
                <Alert variant="outlined" severity="info">
                    {props.message}
                </Alert>`
            </Stack>
            <Stack direction="column" size={6} sx={{ display: 'flex', mt: 2, width: '100px'}}>
                <Button type={"button"} onClick={()=>history.navigate(-1)} variant="outlined" startIcon={<ArrowBackIcon />}>
                    Back
                </Button>
            </Stack>
        </Stack>
    );
}